import { render, staticRenderFns } from "./IndexPost.vue?vue&type=template&id=4f27652d"
import script from "./IndexPost.vue?vue&type=script&lang=js"
export * from "./IndexPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports